import { createSlice } from '@reduxjs/toolkit'

     
let initialState={ 
buyings:[],
categories:[],
products_categories:[],
products_main_categories:[],
announcements:[]
}

export const HomeSlice =  createSlice({
  name: 'home',
  initialState,
  reducers:{
    setHome: (state,action) => {
      state.buyings=action.payload.buyings;
      state.categories=action.payload.categories;
      state.products_categories=action.payload.products_categories;
      state.products_main_categories=action.payload.products_main_categories;
      state.announcements=action.payload.announcements;
    },
  },
})
export const {setHome}=HomeSlice.actions
export default HomeSlice.reducer